import { COLORS } from '@btime/constants'
import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import Container from '../../../components/structure/Container'
import FlexGrid from '../../../components/structure/FlexGrid'
import PageHeader from './PageHeader'
import Panel from '../../../components/structure/Panel'
import PanelsControl from './PanelsControl'
import Separator from '../../../components/helpers/Separator'
import SideBar from './side/SideBar'

const ImportPage = ({ entity }) => {
  return (
    <AbsolutePageTemplate>
      <PageHeader entity={entity} />
      <Container>
        <Separator weight={4} />
        <FlexGrid align="stretch" gutter={0.5}>
          <PanelsControl entity={entity} />

          <Panel flex={5} noMargin lineBorder bgColor={COLORS.transparent}>
            <SideBar entity={entity} />
          </Panel>
        </FlexGrid>

        <Separator weight={4} />
      </Container>
    </AbsolutePageTemplate>
  )
}

export default ImportPage
